import SvgIcon from '@mui/material/SvgIcon'

type AnniversaryIconProps = {
  fill?: string
  ml?: string | number
  mr?: string | number
}
const AnniversaryIcon: React.FC<AnniversaryIconProps> = ({ fill, ml, mr }) => (
  <SvgIcon sx={{ fill, ml, mr }} viewBox="-3 -2 22 22">
    <path d="M14.2222 1.8H13.3333V0H11.5556V1.8H4.44444V0H2.66667V1.8H1.77778C1.30628 1.8 0.854097 1.98964 0.520699 2.32721C0.187301 2.66477 0 3.12261 0 3.6V16.2C0 16.6774 0.187301 17.1352 0.520699 17.4728C0.854097 17.8104 1.30628 18 1.77778 18H14.2222C15.2089 18 16 17.199 16 16.2V3.6C16 3.12261 15.8127 2.66477 15.4793 2.32721C15.1459 1.98964 14.6937 1.8 14.2222 1.8ZM14.2222 16.2H1.77778V7.2H14.2222V16.2ZM14.2222 5.4H1.77778V3.6H14.2222V5.4Z" />
    <path d="M8 13.8022L9.45496 14.6822C9.72141 14.8435 10.0475 14.6051 9.97734 14.3036L9.59169 12.6488L10.8784 11.5339C11.1133 11.3306 10.987 10.9449 10.6785 10.9204L8.98516 10.7766L8.32254 9.21298C8.20334 8.92901 7.79666 8.92901 7.67746 9.21298L7.01484 10.7731L5.32148 10.9169C5.01296 10.9414 4.88674 11.3271 5.12164 11.5304L6.40831 12.6453L6.02266 14.3001C5.95254 14.6016 6.27859 14.84 6.54504 14.6787L8 13.8022Z" />
  </SvgIcon>
)

export default AnniversaryIcon
